import Vue from 'vue'
import Analytics from './analyticsPlugin.js'
import Features from './featuresPlugin.js'

Vue.use(Analytics, { debug: process.env.NODE_ENV !== 'production' })
Vue.use(Features)
